import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';

const cleanUser = {
  name: "",
  email: "",
  company: "",
  password: "",
  mobile: "",
  phone: "",
  personaId: "",
  maxSession: 1,
  maxSessionIndividual: null,
  status: 1,
  role: "",
  parentId: null
}

const user = (state = cleanUser, action) => {
  switch (action.type) {
    case actionTypes.CREATE_USER_SUCCESS:
      return action.user;
    case actionTypes.ADD_NEW_USER:
      return {
        ...cleanUser
      };
    case actionTypes.SELECT_USER:
      return {
        ...action.user
      };
    case actionTypes.SET_NAME:
      return {
        ...state,
        name: action.name
      };
    case actionTypes.SET_EMAIL:
      return {
        ...state,
        email: action.email
      };
    case actionTypes.SET_COMPANY:
      return {
        ...state,
        company: action.company
      };
    case actionTypes.SET_PHONE:
      return {
        ...state,
        phone: action.phone
      };
    case actionTypes.SET_MOBILE:
      return {
        ...state,
        mobile: action.mobile
      };
    case actionTypes.SET_PASSWORD:
      return {
        ...state,
        password: action.password
      };
    case actionTypes.SET_PERSONA_ID:
      return {
        ...state,
        personaId: action.personaId
      };
    case actionTypes.SET_ROLE:
      return {
        ...state,
        role: action.role
      };
    case actionTypes.SET_SUB_CLIENT:
      return {
        ...state,
        parentId: action.parentId,
      };
    case actionTypes.SET_MAX_SESSION_COMPANY:
      return {
        ...state,
        maxSession: parseInt(action.maxSessionCompany, 10)
      };
    case actionTypes.SET_MAX_SESSION_CLIENT:
      return {
        ...state,
        maxSessionIndividual: (action.maxSessionClient !== null) ? parseInt(action.maxSessionClient, 10) : action.maxSessionClient
      };
    case actionTypes.DEACTIVATE_USER_SUCCESS:
    case actionTypes.ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        status: action.status
      }
    default:
      return state;
  }
}

const nameError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_NAME:
      return action.nameError;
    default:
      return state;
  }
}

const emailError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_EMAIL:
      return action.emailError;
    default:
      return state;
  }
}

const companyError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_COMPANY:
      return action.companyError;
    default:
      return state;
  }
}

const maxSessionCompanyError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_MAX_SESSION_COMPANY:
      return action.maxSessionCompanyError;
    default:
      return state;
  }
}

const maxSessionClientError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_MAX_SESSION_CLIENT:
      return action.maxSessionClientError;
    default:
      return state;
  }
}

const passwordError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_PASSWORD:
      return action.passwordError;
    default:
      return state;
  }
}

const mobileError = (state = "", action) => {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER:
      return "";
    case actionTypes.SET_MOBILE:
      return action.mobileError;
    default:
      return state;
  }
}

const snackBarMesage = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CREATE_USER_FAILURE:
    case actionTypes.CREATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_FAILURE:
    case actionTypes.DEACTIVATE_USER_FAILURE:
    case actionTypes.DEACTIVATE_USER_SUCCESS:
    case actionTypes.ACTIVATE_USER_FAILURE:
    case actionTypes.ACTIVATE_USER_SUCCESS:
      return action.message;
    default:
      return state;
  }
}

const actionStatus = (state = false, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.CREATE_USER_SUCCESS:
    case actionTypes.DEACTIVATE_USER_SUCCESS:
    case actionTypes.ACTIVATE_USER_SUCCESS:
      return true;
    case actionTypes.RESET_ACTION_STATUS:
      return false;
    default:
      return state;
  }
}

const openedSnackBar = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_USER_FAILURE:
    case actionTypes.CREATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_FAILURE:
    case actionTypes.DEACTIVATE_USER_FAILURE:
    case actionTypes.DEACTIVATE_USER_SUCCESS:
    case actionTypes.ACTIVATE_USER_FAILURE:
    case actionTypes.ACTIVATE_USER_SUCCESS:
      return true;
    case actionTypes.ADD_NEW_USER:
    case actionTypes.SELECT_USER:
    case actionTypes.CLOSE_SNACK_BAR:
      return false;
    default:
      return state;
  }
}

const openDeleteConfirmation = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_DELETE_CONFIRM:
      return !state;
    case actionTypes.DEACTIVATE_USER_REQUEST:
    case actionTypes.ADD_NEW_USER:
      return false;
    default:
      return state;
  }
}

const openStationsDialog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_STATIONS_DIALOG:
      return !state;
    case actionTypes.ADD_NEW_USER:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  user,
  nameError,
  emailError,
  companyError,
  passwordError,
  mobileError,
  maxSessionCompanyError,
  maxSessionClientError,
  snackBarMesage,
  openDeleteConfirmation,
  openStationsDialog,
  openedSnackBar,
  actionStatus
});

const getCurrentState = state => state.users.userScreen;

export const getUser = state => getCurrentState(state).user

export const getNameError = state => getCurrentState(state).nameError

export const getEmailError = state => getCurrentState(state).emailError

export const getCompanyError = state => getCurrentState(state).companyError

export const getMaxSessionCompany = state => getCurrentState(state).maxSessionCompanyError
export const getMaxSessionClient = state => getCurrentState(state).maxSessionClientError

export const getPasswordError = state => getCurrentState(state).passwordError

export const getMobileError = state => getCurrentState(state).mobileError

export const getIsValid = state => {
  const { user } = getCurrentState(state);

  if(user.role == "system-user"){
    return user.name && user.email && user.mobile && user.role && user.company && user.maxSession && user.maxSessionIndividual;
  }else{
    return user.name && user.email && user.mobile && user.role && user.company && user.maxSession;
  }
  
}

export const getSnackBarMessage = state => getCurrentState(state).snackBarMesage

export const getOpenDeleteConfirmation = state => getCurrentState(state).openDeleteConfirmation

export const getOpenStationsDialog = state => getCurrentState(state).openStationsDialog

export const getOpenedSnackBar = state => getCurrentState(state).openedSnackBar

export const getActionStatus = state => getCurrentState(state).actionStatus